export default __webpack_public_path__ + "static/article-what-type-of-wedding-are-you-35f7bdb5e59d337b47e650e4e723bffb.jpg";